import React from "react";

const Washing_4 = React.forwardRef(
  ({ width = "34", height = "33", viewBox = "0 0 34 33", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.48518 26.1041L0 0.343054L1.97036 0L2.85181 5.06269C2.95586 5.08497 3.07992 5.10709 3.22527 5.12719C3.63028 5.18319 4.12165 5.21339 4.64555 5.21418C5.71218 5.21578 6.79568 5.09584 7.46713 4.8933C8.77563 4.49859 10.7098 3.47879 11.4136 2.96925L11.9815 2.55812L12.5616 2.95184C13.826 3.81001 15.4677 4.85069 17.5 4.85069C19.536 4.85069 20.9416 3.94971 22.4453 2.94721L22.9282 2.62531L23.4472 2.88484C24.455 3.3887 26.1496 4.14519 26.766 4.3153C28.4244 4.77297 30.1276 4.3627 31.3896 3.50611L32 0L33.9704 0.343054L29.4852 26.1041V29.1715H4.48518V26.1041ZM6.48518 25.9313L3.21362 7.14076C3.66108 7.18988 4.14957 7.21343 4.64254 7.21417C5.80612 7.21593 7.10877 7.09041 8.04473 6.80808C9.29834 6.42993 10.9537 5.61003 11.9939 4.97741C13.2764 5.81195 15.1611 6.85069 17.5 6.85069C19.9192 6.85069 21.6628 5.85368 23.0756 4.92877C24.1021 5.41924 25.5337 6.04998 26.234 6.24323C27.8846 6.69876 29.537 6.52966 30.9596 5.97556L27.4852 25.9313V27.1715H6.48518V25.9313Z"
          fill="black"
        />
        <path d="M2 33H32V31H2V33Z" fill="black" />
      </svg>
    );
  },
);

export default Washing_4;
